import { ReactElement } from 'react';
import { colors } from '~/styles/colors';

interface SmartphoneIconProps {
  color?: string;
  size?: number;
}

export function SmartphoneIcon({ color = colors.icon['primary-base'], size = 20 }: Readonly<SmartphoneIconProps>): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="6" y="2" width="12" height="20" rx="2.5" />
      <line x1="11" y1="18" x2="13" y2="18" />
    </svg>
  );
}
